import React, { useContext, useEffect, useState } from "react";
import "../SummaryUpdated/summaryUpdated.css";
import { BsDot } from "react-icons/bs";
import axios from "../../../axios";
import "../SummaryUpdated/summaryUpdated.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { SubStdSelContext } from "../../../SubStdSelContext";
const MAX_CHARACTERS = 25; //Limit for links

export default function SummaryUpdated({ event }) {
  const navigate = useNavigate();

  const [summary, setSummary] = useState(null);
  const [referenceLink, setReferenceLink] = useState([]);
  const [preRead, setPreRead] = useState([]);
  const [activity, setActivity] = useState([]);
  const [assessment, setAssessment] = useState([]);
  const [homework, setHomework] = useState([]);
  const [polls, setPolls] = useState([]);
  const [pollStatus, setPollStatus] = useState([]);
  const [videoLecture, setVideoLecture] = useState([]);
  const [videoLectureValidation, setBBBLecture] = useState(null);
  const [totalsOpt, setTotalsOpt] = useState([]);
  const [rerender, setRerender] = useState(false);
  const [isGettingData, setIsGettingData] = useState(true);
  const { teacherDCM } = useContext(SubStdSelContext);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const { state } = useLocation();
  /**
   * sets how to display day based events on the sj schedule day view component
   * @param {*} param0
   * @returns
   */
  const handleViewClick = async (index, pollId) => {
    const newStatus = JSON.parse(JSON.stringify(pollStatus));

    if (
      newStatus[index]?.status !== "completed" &&
      newStatus[index]?.status !== "submitted"
    ) {
      newStatus[index].status =
        newStatus[index]?.status === "initial" ? "review" : "initial";
      setPollStatus(newStatus);
    } else {
      // send post/put API Request
      const chosenOptionIndex = newStatus[index].selectedOption;
      const chosenOptionValue = polls[index].options[chosenOptionIndex].key;
      const body = {
        correct_answer: chosenOptionValue,
      };
      const res = await axios.post(
        `/api/v1/videoConference/poll/answer/create/pollId/${pollId}`,
        body
      );
      newStatus[index].status = "submitted";
      res && setPollStatus(newStatus);
    }
  };

  const handleOptionClick = (index, optionIndex) => {
    setPollStatus((prevStatus) => {
      const updatedStatus = JSON.parse(JSON.stringify(prevStatus));
      updatedStatus[index].status = "completed";
      updatedStatus[index].selectedOption = optionIndex;
      return updatedStatus;
    });
    setRerender((prev) => !prev);
  };

  const isChecked = (index, optIndex) => {
    return optIndex === pollStatus[index]?.selectedOption;
  };

  // let supplementId = event?.Supplement_id;
  useEffect(() => {

    const getSummary = async () => {
      try {
        let response = await axios.get(`/api/v1/summary/get/${state.supplement_id}`);
        response && setSummary(response.data.data);
        //Here I added loader
        setIsGettingData(false)
        if (response.data.data.bbb_lecture_summary.reference === undefined) {
          setReferenceLink([]);
        } else {
          setReferenceLink(response.data.data.bbb_lecture_summary.reference);
        }

        if (response.data?.data?.pre_read != null || undefined) {
          setPreRead([response.data.data?.pre_read]);
        }

        if (response.data?.data?.activity != null || undefined) {
          setActivity([response?.data?.data?.activity]);
        }

        if (response.data?.data?.assessment != null || undefined) {
          setAssessment([response?.data?.data?.assessment]);
        }

        if (response.data?.data?.homework != null || undefined) {
          setHomework([response?.data?.data?.homework]);
        }

        if (
          response.data.data?.bbb_lecture_summary?.polls != null ||
          undefined
        ) {
          setPolls(response?.data?.data?.bbb_lecture_summary?.polls);
        }
        if (response?.data?.data?.bbb_lecture_summary?.playback_url) {
          setVideoLecture(
            response?.data?.data?.bbb_lecture_summary?.playback_url
          );
        }
        if (
          response?.data?.data?.bbb_lecture_summary &&
          typeof response?.data?.data?.bbb_lecture_summary === "object"
        ) {
          setBBBLecture(response?.data?.data?.bbb_lecture_summary);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getSummary();
  }, [event?.Supplement_id]);

  useEffect(() => {
    if (polls.length > 0) {
      const newPollStatus = polls.map((poll) => ({
        status: poll?.correct_answer?.key !== null ? "submitted" : "initial",
        selectedOption: null,
      }));
      setPollStatus(newPollStatus);
      const totalVotes = polls.map((poll) => {
        const pollTotal = poll.options.reduce(
          (total, option) => total + (option.votes || 0),
          0
        );
        return pollTotal;
      });
      setTotalsOpt(totalVotes);
    }
  }, [polls]);
  function formatTime(time) {
    if (time) {
      const timeString = time.toString();
      const hours = timeString.substring(0, 2);
      const minutes = timeString.substring(2);
      let formattedHours = parseInt(hours);
      let ampm = 'AM';
      if (formattedHours >= 12) {
        ampm = 'PM';
        formattedHours = formattedHours === 12 ? 12 : formattedHours - 12;
      } else if (formattedHours === 0) {
        formattedHours = 12;
      }
      formattedHours = formattedHours < 10 ? '0' + formattedHours : formattedHours;
      const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
      const formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
      return formattedTime;

    }
  }

  return (
    <>
      <div className="summary_container p-4">
        <div className="d-flex gap-2 align-center">
          <img
            className="backArrow_summary"
            src="/DCM-img/BackArrowSummary.svg"
            alt=""
            onClick={() => {
              navigate('/DcmTimeTable')
            }}
          ></img>
          <span className="summary_heading_dcm ">Class Summary</span>
        </div>
        {!isGettingData ?
          <div className="SummaryInnerContainer">
            <div className="SummaryHeader">
              <div className="ContentsOfHeader">
                <div className="subheading_dcm">
                  {" "}
                  {summary?.lecture.name}
                  {/* |{" "}
              {summary?.lecture?.description
                ? summary?.lecture?.description
                : "-"}{" "} */}
                </div>
                {summary && <p className="sumary_time">
                  {new Date(summary?.schedule_date)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "-")}{" "}
                  |{" "}
                  {/* {new Date(summary?.lecture?.start_time).toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}{" "} */}
                  {formatTime(summary?.lecture?.start_time)}
                </p>}
              </div>
              {summary && <div className="ContentsOfHeader">
                <p className="TeachAndSub">
                  <span className="SubjectTeacherHeading">
                    Subject:{" "}
                    <span className="SubjectTeacherValues">{summary?.lecture?.subject.name}</span>
                  </span>
                </p>
                <p className="TeachAndSub">
                  <span className="SubjectTeacherHeading">
                    Teacher:{" "}
                    <span className="SubjectTeacherValues">
                      {summary?.lecture?.teacher?.name}
                    </span>
                  </span>
                </p>
              </div>}
            </div>
            {!videoLectureValidation &&
              !summary &&
              assessment.length === 0 &&
              activity.length === 0 &&
              preRead.length === 0 &&
              homework.length === 0 ? (
              <div class="imgBoxNoSummary">
                <img src="/images/NoSummary1.svg" alt="No Summary" />
              </div>
            ) : (
              <div className=" total_sumarry_container">
                <div className="subContainer1">
                  <div className="Lesson_Description">Lesson Description</div>
                  <p className="Lesson_Description_text">
                    {summary?.bbb_lecture_summary?.meeting_data?.description
                      ? summary?.bbb_lecture_summary?.meeting_data?.description
                      : "-"}
                  </p>
                  <div className="subContainer2">
                    <div className="Relevant_links">
                      Relevant links / references
                    </div>
                    {referenceLink.length === 0 ? ( // change condition when the dynamic data is available for integration
                      <div>
                        <div className="NoLinksText">
                          <BsDot />
                          No Links Added yet!
                        </div>
                      </div>
                    ) : null}
                    {referenceLink.map((item, index) => (
                      <div className="container_links_text">
                        <div className="col-md-8 p-0">
                          <div className="link_text1 d-flex ">
                            {" "}
                            <div>
                              <BsDot />
                            </div>
                            {item}
                          </div>
                        </div>
                        <p
                          className="view_summary"
                          onClick={(event) => {
                            event.preventDefault();
                            window.open(item, "_blank");
                          }}
                        >
                          View
                        </p>
                      </div>
                    ))}
                  </div>
                  <div className="summary_polls">Your Polls</div>
                  {polls.length > 0 ? (
                    <>
                      {polls.map((item, index) => (
                        <div key={`poll_${index}`}>
                          <div className="polls_text1 d-flex">
                            <div>
                              <BsDot />
                            </div>
                            <div>
                              Polls- {index < 10 && 0}
                              {index + 1}
                            </div>
                          </div>
                          {item?.correct_answer?.key ? (
                            <>
                              <div className="container_links_text">
                                <p className="polls_text3 d-flex">
                                  {item.question}
                                </p>
                                <p
                                  className="view_summary"
                                  style={{ border: "none" }}
                                >
                                  Completed
                                </p>
                              </div>

                              <div className="container_links_text">
                                <div className="OptionsContainer">
                                  {item.options.map((opt, optIndex) => (
                                    <label
                                      className="checkbox-container"
                                      style={{
                                        backgroundColor:
                                          opt.key === item?.correct_answer?.key
                                            ? "#FCE7CC"
                                            : "transparent",
                                      }}
                                      key={`polls_option_${optIndex}`}
                                    >
                                      <input
                                        type="checkbox"
                                        className="polls_text2"
                                        checked={
                                          opt.key === item?.correct_answer?.key
                                        }
                                      />
                                      <div className="OptionActualValues">
                                        <div className="OptionActual">
                                          <span className="OptionText">{`${opt.key}`}</span>
                                          <span>
                                            {opt.votes
                                              ? Math.round(
                                                (opt.votes / totalsOpt[index]) *
                                                100
                                              ) + "%"
                                              : "0%"}
                                          </span>
                                        </div>
                                      </div>
                                    </label>
                                  ))}
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="container_links_text">
                                <p className="polls_text3 d-flex">
                                  {item.question}
                                </p>
                                {teacherDCM === "option1" ||
                                  teacherDCM === "option2" ||
                                  (teacherDCM === "option3" && teacher_id === event.Teacher)
                                  ? (
                                    <p
                                      className="view_summary"
                                      onClick={() =>
                                        handleViewClick(index, item.poll_id)
                                      }
                                      style={{
                                        color:
                                          pollStatus[index]?.status === "initial" ||
                                            pollStatus[index]?.status === "review"
                                            ? "#335C76"
                                            : "#F77F00",
                                        borderBottom:
                                          pollStatus[index]?.status === "submitted"
                                            ? "none"
                                            : "1px solid",
                                        borderColor:
                                          pollStatus[index]?.status === "initial"
                                            ? "#335C76"
                                            : "#F77F00",
                                      }}
                                    >
                                      {pollStatus[index]?.status === "initial"
                                        ? "Review"
                                        : pollStatus[index]?.status === "review"
                                          ? "⦿ On Review"
                                          : pollStatus[index]?.status === "completed"
                                            ? "Done"
                                            : "Completed"}
                                    </p>
                                  ) : (
                                    <></>
                                  )}
                              </div>
                              <div className="container_links_text">
                                <div className="OptionsContainer">
                                  {item.options.map((opt, optIndex) => (
                                    <label
                                      className="checkbox-container"
                                      style={{
                                        backgroundColor:
                                          pollStatus[index]?.status === "review"
                                            ? "rgb(235,239,241)"
                                            : pollStatus[index]?.status ===
                                              "completed"
                                              ? optIndex ===
                                                pollStatus[index]?.selectedOption
                                                ? "#FCE7CC"
                                                : "rgb(235,239,241)"
                                              : pollStatus[index]?.status ===
                                                "submitted"
                                                ? optIndex ===
                                                  pollStatus[index]?.selectedOption
                                                  ? "#FCE7CC"
                                                  : "transparent"
                                                : "transparent",
                                      }}
                                      key={`polls_option_${optIndex}`}
                                    >
                                      <input
                                        type="checkbox"
                                        key={`${index}-${optIndex}-${rerender}`}
                                        className="polls_text2"
                                        onClick={() => {
                                          (pollStatus[index]?.status ===
                                            "review" ||
                                            pollStatus[index]?.status ===
                                            "completed") &&
                                            handleOptionClick(index, optIndex);
                                        }}
                                        checked={isChecked(index, optIndex)}
                                      />
                                      <div className="OptionActualValues">
                                        <div className="OptionActual">
                                          <span className="OptionText">{`${opt.key}`}</span>
                                          <span>
                                            {opt.votes
                                              ? Math.round(
                                                (opt.votes / totalsOpt[index]) *
                                                100
                                              ) + "%"
                                              : "0%"}
                                          </span>
                                        </div>
                                      </div>
                                    </label>
                                  ))}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="link_text1 d-flex ">
                      {" "}
                      <div>
                        <BsDot />
                      </div>
                      No polls created
                    </div>
                  )}
                </div>
                <div className=" subContainer2">
                  <div className="subContainer2_heading">Your Pre-read</div>
                  {preRead.length > 0 ? (
                    <div>
                      {preRead.map((item, index) => (
                        <div>
                          <div className=" polls_text1 d-flex">
                            <div>
                              <BsDot />
                            </div>
                            <div>{item.name}</div>
                          </div>
                          <div className="container_links_text_left">
                            {item.description.length > MAX_CHARACTERS ? (
                              <p className="polls_text2">
                                {`${item.description.slice(
                                  0,
                                  MAX_CHARACTERS
                                )}...`}
                              </p>
                            ) : (
                              <p className="polls_text2">{item.description}</p>
                            )}
                            {/* prevent the undefined issue add {} */}
                            <div onClick={() => { localStorage.setItem("from", "Summary"); localStorage.setItem("supplementId", JSON.stringify(state.supplement_id || {})) }}>
                              <NavLink
                                to={`/PublishedQListPreRead`}
                                className="link"
                                state={{ publishPre_id: item.id }}
                              >
                                <p className="view_summary">View</p>
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="polls_text2">
                      Pre Read Not added Please Check Later.
                    </p>
                  )}
                  <div className="subContainer2_heading">Your Activity</div>
                  {activity.length > 0 ? (
                    <div>
                      {activity.map((item, index) => (
                        <>
                          <div>
                            <div className=" polls_text1 d-flex">
                              <div>
                                <BsDot />
                              </div>
                              <div>{item.name}</div>
                            </div>
                            <div className="container_links_text_left">
                              <p className="polls_text2">
                                {item.description.length > MAX_CHARACTERS ? (
                                  <p className="polls_text2">
                                    {`${item.description.slice(
                                      0,
                                      MAX_CHARACTERS
                                    )}...`}
                                  </p>
                                ) : (
                                  <p className="polls_text2">
                                    {item.description}
                                  </p>
                                )}
                              </p>
                              <div onClick={() => { localStorage.setItem("from", "Summary"); localStorage.setItem("supplementId", JSON.stringify(state.supplement_id) || {}) }}>
                                <NavLink
                                  to={`/PublishedQListActvity`}
                                  className="link"
                                  state={{ publishedActivity_id: item.id }}
                                >
                                  <p className="view_summary">View</p>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        </>
                      ))}
                    </div>
                  ) : (
                    <p className="polls_text2">
                      Activity Not added Please Check Later.
                    </p>
                  )}

                  <div className="subContainer2_heading">Your Assessment</div>
                  {assessment.length > 0 ? (
                    <div>
                      {assessment.map((item, index) => (
                        <div>
                          <div className=" polls_text1 d-flex">
                            <div>
                              <BsDot />
                            </div>
                            <div>{item.name}</div>
                          </div>
                          <div className="container_links_text_left">
                            <p className="polls_text2">
                              {item.description.length > MAX_CHARACTERS ? (
                                <p className="polls_text2">
                                  {`${item.description.slice(
                                    0,
                                    MAX_CHARACTERS
                                  )}...`}
                                </p>
                              ) : (
                                <p className="polls_text2">{item.description}</p>
                              )}
                            </p>
                            <div onClick={() => { localStorage.setItem("from", "Summary"); localStorage.setItem("supplementId", JSON.stringify(state.supplement_id) || {}) }}>
                              {/* Here remove id from url */}
                              <NavLink
                                to={`/PublishedQList`}
                                className="link"
                                state={{ publishPre_id: item.id }}
                              >
                                <p className="view_summary">View</p>
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="polls_text2">
                      Assessment Not added Please Check Later.
                    </p>
                  )}

                  <div className="subContainer2_heading">Your Homework</div>
                  {homework.length > 0 ? (
                    <div>
                      {homework.map((item, index) => (
                        <div>
                          <div className=" polls_text1 d-flex">
                            <div>
                              <BsDot />
                            </div>
                            <div>{item.name}</div>
                          </div>
                          <div className="container_links_text_left">
                            <p className="polls_text2">
                              {item.description.length > MAX_CHARACTERS ? (
                                <p className="polls_text2">
                                  {`${item.description.slice(
                                    0,
                                    MAX_CHARACTERS
                                  )}...`}
                                </p>
                              ) : (
                                <p className="polls_text2">{item.description}</p>
                              )}
                            </p>
                            <div onClick={() => { localStorage.setItem("from", "Summary"); localStorage.setItem("supplementId", JSON.stringify(state.supplement_id), {}) }}>
                              <NavLink
                                to={`/PublishedQListHW`}
                                className="link"
                                state={{ homework_id: item.id }}
                              >
                                <p className="view_summary">View</p>
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="polls_text2">
                      Homework Not added Please Check Later.
                    </p>
                  )}

                  <div className="subContainer2_heading">
                    Lecture Video Recording
                  </div>
                  {videoLectureValidation === null ? (
                    <div>
                      {
                        <div>
                          <div className=" polls_text1 d-flex">
                            <div>
                              <BsDot />
                            </div>
                            <div>Video not available</div>
                          </div>
                          <div className="container_links_text_left">
                            <p className="polls_text2">
                              Please check after some time.
                            </p>
                            <p></p>
                          </div>
                        </div>
                      }
                    </div>
                  ) : (
                    <div>
                      {videoLecture.map((item, index) => (
                        <div>
                          <div className=" polls_text1 d-flex">
                            <div>
                              <BsDot />
                            </div>
                            <div>Video recording available</div>
                          </div>
                          <div className="container_links_text_left">
                            <p className="polls_text2">
                              Lecture Recording -{index + 1}
                            </p>
                            <p
                              className="view_summary"
                              onClick={(event) => {
                                event.preventDefault();
                                window.open(item, "_blank");
                              }}
                            >
                              View
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          : (<img className="ongoing_loader" style={{ marginLeft: "680px" }} src="/gif/LoaderDot.gif" alt="" />)}

        {/* <Link
        className="link"
        to={`/liveSession/${state.supplementId}/${stdSelectedOption}/${secSelectedOption}`}
      >
        <div className="container_Edit_Summary">
          <button className="Edit_Summary">Edit Summary</button>
        </div>
      </Link> */}
      </div>
    </>
  );
}
